import React from 'react';
import PropTypes from 'prop-types';

export const teamsByLeagueListPropTypes = {
    teams: PropTypes.array
};